{
  "title": "如何發布公告並寄 Email 通知",
  "description": "新增競賽公告，並選擇是否同時以 Email 通知學生、教師或評審；含預覽、測試信、收件人範圍與寄送上限。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，公告會顯示在競賽頁，並依你的選擇寄給指定收件人。",
  "roleNote": "主辦方",
  "prerequisites": ["具備管理公告的競賽權限", "若要寄 Email，競賽設定已填寫「聯絡信箱」"],
  "pathLabel": "競賽管理 → 營運 → 公告",
  "steps": [
    {
      "title": "1. 撰寫公告",
      "description": "在「公告」頁新增公告，填寫標題與內容（純文字，換行會保留，網址會自動變成連結）。「顯示對象（網站）」可選全部（含訪客）、參賽者、評審，只決定網站上誰看得到。只按「發布公告」不會寄出任何信，網站公告與 Email 是兩件事。"
    },
    {
      "title": "2. 預覽與寄測試信",
      "description": "按「預覽」查看公告呈現；按「寄測試信給我自己」會只寄給你本人並標示【測試】，不會建立公告，也不會寄給任何收件人。第一次使用建議先寄測試信。"
    },
    {
      "title": "3. 選擇要不要寄 Email 與收件人",
      "description": "勾選「同時寄 Email 通知」，選擇角色（學生、教師、評審），並可再依類別、輪次、報名欄位（例如「參賽組別」）縮小範圍；這些條件只縮小學生與教師，不影響評審。畫面會即時顯示「預計寄送：N 位收件人」，人數為 0 時無法寄送。每次寄送上限 300 位，超過時請縮小條件並分批寄送。"
    },
    {
      "title": "4. 確認並寄出",
      "description": "按「發布並寄送 Email」後會出現確認對話框，顯示人數與實際會寄出的主旨與內文；按「取消」什麼都不會發生，按「確認寄送」才會建立公告並寄信。已發布的公告也可以在清單按「寄送 Email」補寄，清單會顯示每則公告是否已寄過與寄給幾位，重複寄送時對話框會提醒。"
    }
  ],
  "afterward": [
    "公告顯示在公開競賽頁與參賽者的「競賽資訊」頁",
    "每次寄送會在稽核紀錄留下摘要（成功與失敗人數，不含 Email 位址）",
    "已寄出的 Email 無法收回，之後編輯或刪除公告也不會更新已寄出的信"
  ],
  "nextSteps": "若要提醒特定學生補填報名資料，請見「需補填的報名資料與提醒信」。",
  "faq": [
    {
      "q": "發布公告後，學生沒有收到 Email？",
      "a": "公告預設只顯示在網站；要寄信必須勾選「同時寄 Email 通知」或事後按「寄送 Email」。若已寄出仍收不到，請檢查收件人條件與預計人數、垃圾郵件匣，以及稽核紀錄中該次寄送的失敗人數。"
    },
    {
      "q": "公告 Email 可以用格式或附件嗎？",
      "a": "不行。信件內文一律當作純文字處理，不支援格式與附件；信末會註明為競賽官方通知並附上主辦單位聯絡信箱。"
    },
    {
      "q": "超過 300 位怎麼辦？",
      "a": "請用類別、輪次或報名欄位縮小條件，分次寄送。"
    },
    {
      "q": "寄錯了可以收回嗎？",
      "a": "不行。所以建議先寄測試信，再用小範圍條件寄出，確認無誤後再擴大。"
    }
  ]
}
